import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import SugargooReviewPage from "@/pages/article/sugargoo-review/page";
import SugargooShippingCostPage from "@/pages/article/sugargoo-shipping-cost/page";
import SugargooCouponGuidePage from "@/pages/article/sugargoo-coupon-guide/page";
import SugargooWarehouseGuidePage from "@/pages/article/sugargoo-warehouse-guide/page";
import BestSugargooFindsPage from "@/pages/article/best-sugargoo-finds/page";
import SugargooBeginnersGuidePage from "@/pages/article/sugargoo-beginners-guide/page";
import SugargooVsOtherAgentsPage from "@/pages/article/sugargoo-vs-other-agents/page";
import SugargooQcGuidePage from "@/pages/article/sugargoo-qc-guide/page";
import SugargooTipsTricksPage from "@/pages/article/sugargoo-tips-tricks/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sugargoo-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/sugargoo-review",
    element: <SugargooReviewPage />,
  },
  {
    path: "/sugargoo-shipping-cost",
    element: <SugargooShippingCostPage />,
  },
  {
    path: "/sugargoo-coupon-guide",
    element: <SugargooCouponGuidePage />,
  },
  {
    path: "/sugargoo-warehouse-guide",
    element: <SugargooWarehouseGuidePage />,
  },
  {
    path: "/best-sugargoo-finds",
    element: <BestSugargooFindsPage />,
  },
  {
    path: "/sugargoo-beginners-guide",
    element: <SugargooBeginnersGuidePage />,
  },
  {
    path: "/sugargoo-vs-other-agents",
    element: <SugargooVsOtherAgentsPage />,
  },
  {
    path: "/sugargoo-qc-guide",
    element: <SugargooQcGuidePage />,
  },
  {
    path: "/sugargoo-tips-tricks",
    element: <SugargooTipsTricksPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;